import { Box, Skeleton, Stack } from "@mui/material";
import { LSResultItemLayout } from "./LSResultItemLayout";
import { useIsMobile } from "@tlc/ui/useIsMobile";
import React from "react";

export function LSResultItemAvailabilitySkeleton() {
  return (
    <Skeleton
      variant="text"
      sx={{ pt: "0.5em", pb: "0.5em" }}
      height={40}
      width={"100%"}
    />
  );
}
interface LSResultItemSkeletonProps {
  hideCheckbox?: boolean;
  hideActions?: boolean;
}
export function LSResultItemSkeleton({
  hideActions = false,
  hideCheckbox = false,
}: LSResultItemSkeletonProps) {
  const isMobile = useIsMobile();
  return (
    <LSResultItemLayout
      bookjacketComponent={
        <Skeleton variant="rectangular" width={132} height={200} />
      }
      titleComponent={<Skeleton variant="text" height={32} width={"100%"} />}
      actionsComponent={
        hideActions ? undefined : (
          <>
            <Skeleton variant="rounded" width={130} height={36.5} />
            <Skeleton
              variant="rounded"
              width={isMobile ? 40 : 130}
              height={36.5}
            />
          </>
        )
      }
      checkboxComponent={
        hideCheckbox ? undefined : (
          <Skeleton
            sx={{ margin: "9px" }}
            variant={"rectangular"}
            width={24}
            height={24}
          />
        )
      }
      authorComponent={<Skeleton variant="text" height={24} width={160} />}
    >
      {/* Format and Rating */}
      <Box display="flex" alignItems="center" gap={2}>
        <Skeleton variant="rounded" width={54} height={32} />
        {/* Five stars */}
        <Stack direction="row">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} variant="circular" width={24} height={24} />
          ))}
        </Stack>
      </Box>

      {/* Availability */}
      <LSResultItemAvailabilitySkeleton />

      {/* Shelf Location */}
      {/* TODO Skeleton */}
    </LSResultItemLayout>
  );
}
